import { IGetServerTimeApiResponse } from "../models/timer/IGetServerTimeApiResponse";
import HttpProvider from "../providers/HttpProvider";

export default class TimerApi {
    public static async GetServerTime(): Promise<IGetServerTimeApiResponse> {
        const uriStr = `${this.apiUrl}/get-server-time`;

        const response = await HttpProvider.GetRequest(uriStr);

        return await response.json();
    }

    private static readonly apiUrl = "/api/Timer";
}
